var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.85 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3,36c-.83,0-1.53-.29-2.12-.88s-.88-1.29-.88-2.12V3c0-.83.29-1.53.88-2.12s1.29-.88,2.12-.88h25.15l7.85,7.85v12.9l-3,3v-14.55l-6.2-6.2H3v30h20.8l-3,3H3Zm14.99-6.25c1.44,0,2.67-.5,3.69-1.51,1.02-1.01,1.53-2.23,1.53-3.68s-.5-2.67-1.51-3.69c-1.01-1.02-2.23-1.53-3.68-1.53s-2.67.5-3.69,1.51c-1.02,1.01-1.53,2.23-1.53,3.68s.5,2.67,1.51,3.69c1.01,1.02,2.23,1.53,3.68,1.53ZM5.65,12.8h17.9v-7.15H5.65v7.15Zm17.85,27.2v-2.5l11.4-11.4,2.5,2.5-11.4,11.4h-2.5Zm15.2-12.7l-2.5-2.5,1.95-1.95c.2-.2.38-.3.53-.3s.33.1.53.3l1.35,1.35c.2.2.3.41.3.63s-.1.43-.3.63l-1.85,1.85ZM3,33V3v30Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f1d1e502ad8dadbaac211418ffda239c.svg";
export { ForwardRef as ReactComponent };